import { Button, DatePicker, Divider, Form, Space } from '@oscar/theme';
import { FORMAT_DATE } from 'common/constants';
import moment from 'moment';
import React, { useEffect } from 'react';
import './style.scss';

function FilterDateRangeColumnTable(props: any) {
  const { setSelectedKeys, selectedKeys, confirm, visible } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) {
      confirm();
    }
  }, [visible]);

  useEffect(() => {
    if (selectedKeys && selectedKeys?.length) {
      form.setFieldsValue({
        startDate: selectedKeys?.[0] && moment(selectedKeys?.[0]),
        endDate: selectedKeys?.[1] && moment(selectedKeys?.[1]),
      });
    }
  }, [selectedKeys]);

  const disabledDate = (current: any) => {
    if (!selectedKeys?.[0]) {
      return false;
    }
    return moment(selectedKeys?.[0]) > current;
  };

  const handleStartDateChange = (date: any) => {
    setSelectedKeys([date]);
  };

  const handleEndDateChange = (date: any) => {
    setSelectedKeys([selectedKeys?.[0], date]);
  };

  const handleClearFilter = () => {
    form.resetFields();
    setSelectedKeys([]);
  };

  return (
    <div className="ant-table-column-filter-date-range">
      <Form form={form} layout="vertical">
        <Space>
          <Form.Item name="startDate" label="Start Date">
            <DatePicker
              allowClear
              placeholder=""
              inputReadOnly={true}
              onChange={handleStartDateChange}
              format={FORMAT_DATE.SHORT_MONTH_DATE}
            />
          </Form.Item>

          <Form.Item name="endDate" label="End Date">
            <DatePicker
              allowClear
              placeholder=""
              inputReadOnly={true}
              disabledDate={disabledDate}
              onChange={handleEndDateChange}
              format={FORMAT_DATE.SHORT_MONTH_DATE}
            />
          </Form.Item>
        </Space>
      </Form>
      <Divider className="margin-divider" />
      <Button type="link" size="small" onClick={handleClearFilter}>
        Clear Filter
      </Button>
    </div>
  );
}

export default FilterDateRangeColumnTable;
